import { uiStore } from "@/store/store";
import { toggleAndSetPanelStateToAdvanced } from "./util";

export function openElementCustomCssAndFocusCodeMirror() {
  uiStore.setKeyboardTriggeredActions({
    ...uiStore.keyboardTriggeredActions,
    focusCodeMirror: "pending"
  });

  toggleAndSetPanelStateToAdvanced();
}
